import React from 'react';
import { Globals } from '../../global/Globals';
import './Carousal.css';
import Loader from '../../components/Loader/Loader';

const DefaultCarousal = () => {
    return (
        <>
            <div id="slide-header" className='slide-header'>
                <div id="app-logo" className="app-logo">
                    <img src={Globals.IMG.CAROUSAL_LOGO} alt="logo" />
                </div>
                <div>

                    <Loader height={50} width={50} component={"default_Carousel"} />
                </div>
            </div>
        </>
    );
};

export default DefaultCarousal;